import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import Tree from '~/components/Tree';
import BCIF_Container from '../BCIF_Container';
import Boat2 from 'images/Boat2.png';

const Png = ({ open }) => (
  <img
    style={{
      position: 'absolute',
      bottom: 0,
      right: open ? -28 : 10,
      width: open ? 366 : 287 * 0.4,
      pointerEvents: 'none',
      opacity: open ? 1 : 0.5,
      transition: 'all 2s',
      objectFit: 'contain',
    }}
    src={Boat2}
    alt=''
  />
);

const App = ({ windId }) => {
  const dispatch = useDispatch();
  const BIPCEquity = useSelector(state => state.data.BIPCEquity || {});
  const { review_results, change_equity } = BIPCEquity;
  const isAgree = review_results === '1';
  let haveData = false;
  try {
    if (JSON.parse(change_equity).length)haveData = true;
  } catch {}

  useEffect(() => {
    Actions_Wind.getBIPCEquity(dispatch, { windId });
    return () => Actions_Wind.clearKey(dispatch, { key: 'BIPCEquity' });
  }, []);
  return (
    <BCIF_Container title='是否申請股權變更' defaultOpen={false}>
      {!isAgree && <div style={{ margin: 20, fontSize: 20, textAlign: 'center' }}>(未同意變更)</div>}
      {isAgree && !haveData && <div style={{ margin: 20, fontSize: 20, textAlign: 'center' }}>(暫無資料)</div>}
      {isAgree && haveData && <Tree disabled data={change_equity} />}
      <Png />
    </BCIF_Container>
  );
};

export default App;
